import { QuoteCreationStepStateType } from "@/common/types/quote";
import QuoteModalFirstStep from "./QuoteModalFirstStep";
import QuoteModalSecondStep from "./QuoteModalSecondStep";

const stateKeys = ["firstStepData", "secondStepData"] as const;
type StateKeys = (typeof stateKeys)[number];
interface QuoteModalStepsProps {
  currentStep: number;
  globalState: QuoteCreationStepStateType;
  updateFunc: (productName: StateKeys, fieldName: string, value: any) => void;
  validationErrors: Record<string, string>;
  removeErrors: (fieldName: string) => void;
  updateIsResults: (value: boolean) => void;
}

export default function QuoteModalStepsContent({
  currentStep,
  globalState,
  removeErrors,
  updateFunc,
  validationErrors,
}: QuoteModalStepsProps) {
  switch (currentStep) {
    case 0:
      return (
        <QuoteModalFirstStep
          validationErr={validationErrors}
          updateFunc={updateFunc}
          firstStepState={globalState.firstStepData}
          removeErrors={removeErrors}
        />
      );
    case 1:
      return (
        <QuoteModalSecondStep
          globalState={globalState}
          validationErr={validationErrors}
          updateFunc={updateFunc}
          removeErrors={removeErrors}
        />
      );
    default:
      break;
  }
}
